import { gql } from '@apollo/client'

export const loginMutation = gql`
  mutation ($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      statusCode
      error
      enterpriseSsoLoginUrl
    }
  }
`

export const login2faMutation = gql`
  mutation ($token: String!) {
    login2fa(token: $token) {
      statusCode
      error
    }
  }
`

export const requestLogin2faCodeMutation = gql`
  mutation {
    requestLogin2faCode {
      statusCode
    }
  }
`

export const sendResetPasswordEmailMutation = gql`
  mutation ($email: String!) {
    requestPasswordResetEmail(email: $email) {
      statusCode
      error
    }
  }
`

export const resetPasswordMutation = gql`
  mutation ($jwt: String!, $newPassword: String!) {
    resetPassword(jwt: $jwt, newPassword: $newPassword) {
      statusCode
      error
    }
  }
`

export const signupMutation = gql`
  mutation ($email: String!, $password: String!, $name: String!) {
    signUp(email: $email, password: $password, name: $name) {
      statusCode
      error
      user {
        email
      }
    }
  }
`

export const resendEmailMutation = gql`
  mutation ($email: String!) {
    requestEmailConfirmationEmail(email: $email) {
      statusCode
      error
    }
  }
`

export const getEnterpriseAuthRedirect = gql`
  mutation ($email: String!) {
    getEnterpriseAuthRedirect(email: $email) {
      redirectUrl
    }
  }
`

export const getEnterpriseIsValidStripeCode = gql`
  mutation ($code: String!) {
    getEnterpriseIsValidStripeCode(code: $code) {
      isValid
    }
  }
`
